var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "van-dialog",
    {
      staticClass: "unlock-dialog",
      attrs: {
        value: _vm.show,
        title: "课程未解锁",
        "show-confirm-button": !_vm.showBackButton && !_vm.loading,
        "confirm-button-text": "我知道了",
        "confirm-button-color": "#d51900",
        "close-on-click-overlay": !_vm.showBackButton && !_vm.loading,
        "get-container": "body",
        "lock-scroll": false
      },
      on: { input: _vm.onDialogInput }
    },
    [
      _c(
        "div",
        { staticClass: "unlock-tip-content" },
        [
          _vm.loading
            ? _c("div", { staticClass: "unlock-skeleton" }, [
                _c("div", { staticClass: "skeleton-icon" }),
                _vm._v(" "),
                _c("div", { staticClass: "skeleton-line skeleton-rule" }),
                _vm._v(" "),
                _c("div", { staticClass: "skeleton-line skeleton-progress" }),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "skeleton-course-list" },
                  _vm._l(3, function(i) {
                    return _c(
                      "div",
                      { key: i, staticClass: "skeleton-course-item" },
                      [
                        _c("div", { staticClass: "skeleton-dot" }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "skeleton-line skeleton-course-name"
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "skeleton-line skeleton-course-action"
                        })
                      ]
                    )
                  }),
                  0
                ),
                _vm._v(" "),
                _c("div", { staticClass: "skeleton-line skeleton-hint" })
              ])
            : [
                _c("div", { staticClass: "unlock-icon-large" }, [_vm._v("🔐")]),
                _vm._v(" "),
                _c("p", { staticClass: "unlock-rule" }, [
                  _vm._v(
                    _vm._s(
                      _vm.unlockData.UnlockRuleDesc || "需完成前置课程后解锁"
                    )
                  )
                ]),
                _vm._v(" "),
                _vm.hasMultipleRules
                  ? _c(
                      "div",
                      { staticClass: "rules-container" },
                      _vm._l(_vm.unlockData.UnlockRules, function(
                        rule,
                        ruleIdx
                      ) {
                        return _c(
                          "div",
                          {
                            key: rule.RuleId,
                            staticClass: "rule-block",
                            class: { "rule-satisfied": rule.IsSatisfied }
                          },
                          [
                            _c("div", { staticClass: "rule-header" }, [
                              _c("span", {
                                staticClass: "rule-status-dot",
                                class: rule.IsSatisfied
                                  ? "dot-green"
                                  : "dot-orange"
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "rule-desc-inline" }, [
                                _vm._v(_vm._s(rule.UnlockTypeDesc))
                              ])
                            ]),
                            _vm._v(" "),
                            rule.PreCurriculumList &&
                            rule.PreCurriculumList.length > 0
                              ? _c(
                                  "div",
                                  { staticClass: "precourse-items" },
                                  _vm._l(rule.PreCurriculumList, function(
                                    course
                                  ) {
                                    return _c(
                                      "div",
                                      {
                                        key: course.Id,
                                        staticClass: "precourse-item",
                                        class: {
                                          completed: course.IsCompleted
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.goToCourse(course)
                                          }
                                        }
                                      },
                                      [
                                        _c("span", {
                                          staticClass: "status-dot",
                                          class: course.IsCompleted
                                            ? "dot-green"
                                            : "dot-red"
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          { staticClass: "precourse-name" },
                                          [_vm._v(_vm._s(course.Subject))]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          { staticClass: "precourse-action" },
                                          [
                                            course.IsCompleted
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticClass: "action-done"
                                                  },
                                                  [_vm._v("✓ 已完成")]
                                                )
                                              : _c(
                                                  "span",
                                                  { staticClass: "action-go" },
                                                  [_vm._v("去学习 ›")]
                                                )
                                          ]
                                        )
                                      ]
                                    )
                                  }),
                                  0
                                )
                              : _vm._e()
                          ]
                        )
                      }),
                      0
                    )
                  : _vm.hasCourseList
                  ? _c("div", { staticClass: "precourse-list" }, [
                      _c("p", { staticClass: "precourse-title" }, [
                        _vm._v("📋 前置课程完成情况：")
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "precourse-items" },
                        _vm._l(_vm.displayCourseList, function(course) {
                          return _c(
                            "div",
                            {
                              key: course.Id,
                              staticClass: "precourse-item",
                              class: { completed: course.IsCompleted },
                              on: {
                                click: function($event) {
                                  return _vm.goToCourse(course)
                                }
                              }
                            },
                            [
                              _c("span", {
                                staticClass: "status-dot",
                                class: course.IsCompleted
                                  ? "dot-green"
                                  : "dot-red"
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "precourse-name" }, [
                                _vm._v(_vm._s(course.Subject))
                              ]),
                              _vm._v(" "),
                              _c("span", { staticClass: "precourse-action" }, [
                                course.IsCompleted
                                  ? _c("span", { staticClass: "action-done" }, [
                                      _vm._v("✓ 已完成")
                                    ])
                                  : _c("span", { staticClass: "action-go" }, [
                                      _vm._v("去学习 ›")
                                    ])
                              ])
                            ]
                          )
                        }),
                        0
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("p", { staticClass: "unlock-hint" }, [
                  _vm._v("完成上述课程后，此课程将自动解锁")
                ]),
                _vm._v(" "),
                _vm.showBackButton
                  ? _c("div", { staticClass: "dialog-actions" }, [
                      _c(
                        "button",
                        { staticClass: "btn-back", on: { click: _vm.onBack } },
                        [_vm._v("返回上一页")]
                      )
                    ])
                  : _vm._e()
              ]
        ],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1cec795f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1cec795f","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/UnlockTipDialog.vue
// module id = null
// module chunks = 